var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 10.2266C19.1719 15.7539 15.3867 19.6875 9.79688 19.6875C4.4375 19.6875 0.109375 15.3594 0.109375 10C0.109375 4.64062 4.4375 0.3125 9.79688 0.3125C12.4062 0.3125 14.6016 1.26953 16.293 2.84766L13.6562 5.38281C10.207 2.05469 3.79297 4.55469 3.79297 10C3.79297 13.3789 6.49219 16.1172 9.79688 16.1172C13.6328 16.1172 15.0703 13.3672 15.2969 11.9414H9.79688V8.60938H19.0195C19.1094 9.10547 19.1719 9.58203 19.1719 10.2266Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.e6d6d7981102084779afbcb6c6ab61a0.svg";
export { ForwardRef as ReactComponent };